<main class="mat-body">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress [percent]="20"></thr-contract-progress>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-4 mb-5" *ngIf="isLegalPerson">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">{{ 'form.business'|translate }}</h2>
                <table class="table participants">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{{ 'form.social-name'|translate }}</th>
                            <th class="d-none d-md-table-cell">{{ 'form.document'|translate }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
                            <tr *ngIf="isFirst">
                                <td>
                                    <i class="icon-legal"></i>
                                </td>
                                <td>
                                    <strong>{{ participant.name }}</strong>
                                </td>
                                <td class="d-none d-md-table-cell">
                                    <strong>{{ participant.docId }}</strong>
                                </td>
                                <td class="text-right">
                                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(participant, isFirst)">
                                        <i class="icon-edit"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row mt-4 mb-5">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">
                    <span *ngIf="!isLegalPerson">{{ 'form.participants'|translate }}</span>
                    <span *ngIf="isLegalPerson">{{ 'form.attorneys-in-fact'|translate }}</span>
                </h2>
                <table class="table participants">
                    <thead>
                        <tr>
                            <th></th>
                            <th *ngIf="!isLegalPerson">{{ 'form.participants'|translate }}</th>
                            <th>{{ 'form.name-and-surname'|translate }}</th>
                            <th class="d-none d-md-table-cell">{{ 'form.document'|translate }}</th>
                            <th class="d-none d-md-table-cell">{{ 'form.phone'|translate }}</th>
                            <th class="d-none d-md-table-cell" *ngIf="!isLegalPerson">{{ 'form.condition'|translate }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
                            <ng-container *ngIf="!isLegalPerson || (isLegalPerson && !isFirst)">
                                <tr [class.gray]="participant.legalGuardians && participant.legalGuardians.length > 0">
                                    <td>
                                        <i class="icon-legal" *ngIf="participant.type === ClientType.LEGAL_PERSON"></i>
                                        <i class="icon-minor-plus" *ngIf="participant.type === ClientType.MINOR"></i>
                                        <i class="icon-disabled-plus" *ngIf="participant.type === ClientType.DISABLED"></i>
                                        <i class="icon-natural-plus" *ngIf="participant.type === ClientType.NATURAL_PERSON"></i>
                                    </td>
                                    <td *ngIf="!isLegalPerson">
                                        <strong class="text-uppercase text-blue" *ngIf="participant.relation === ClientRelation.HOLDER">
                                            <ng-container *ngIf="participant.isSoleHolder">{{ 'form.holder'|translate }}</ng-container>
                                            <ng-container *ngIf="!participant.isSoleHolder">{{ 'form.co-holder'|translate }}</ng-container>
                                        </strong>
                                        <strong class="text-uppercase text-blue" *ngIf="participant.relation === ClientRelation.AUTHORIZED">
                                            {{ 'form.authorized'|translate }}
                                        </strong>
                                    </td>
                                    <td><strong>{{ participant.name }}</strong>&nbsp;<strong>{{ participant.surname }}</strong></td>
                                    <td class="d-none d-md-table-cell">
                                        <strong>{{ participant.docId }}</strong>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <strong>{{ participant.phone }}</strong>
                                    </td>
                                    <td class="d-none d-md-table-cell" *ngIf="!isLegalPerson">
                                        <strong class="text-uppercase text-blue" *ngIf="participant.type === ClientType.MINOR">
                                            {{ 'form.minor-person'|translate }}
                                        </strong>
                                        <strong class="text-uppercase text-blue" *ngIf="participant.type === ClientType.DISABLED">
                                            {{ 'form.disabled-person'|translate }}
                                        </strong>
                                        <strong *ngIf="participant.type !== ClientType.DISABLED && participant.type !== ClientType.MINOR">
                                            -
                                        </strong>
                                    </td>
                                    <td class="text-right">
                                        <button
                                            type="button"
                                            class="mat-elevation-z0"
                                            mat-icon-button
                                            (click)="onEdit(participant, isFirst)"
                                            *ngIf="!participant.preload"
                                        >
                                            <i class="icon-edit"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="mat-elevation-z0"
                                            mat-icon-button
                                            (click)="onRemove(participant)"
                                            *ngIf="!isFirst && !participant.preload"
                                        >
                                            <i class="icon-delete"></i>
                                        </button>
                                    </td>
                                </tr>
                                <ng-template
                                    ngFor
                                    let-legalGuardian
                                    [ngForOf]="participant.legalGuardians"
                                    let-isFirstLG="first"
                                    let-isLastLG="last"
                                >
                                    <tr [class.gray]="!isLastLG">
                                        <td></td>
                                        <td>
                                            <span
                                                *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length > 1"
                                                >{{ 'form.representatives'|translate }}:</span
                                            >
                                            <span
                                                *ngIf="isFirstLG && participant.type === ClientType.DISABLED && participant.legalGuardians.length === 1"
                                                >{{ 'form.the-representative'|translate }}:</span
                                            >
                                            <span
                                                *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length > 1"
                                                >{{ 'form.tutors'|translate }}:</span
                                            >
                                            <span
                                                *ngIf="isFirstLG && participant.type === ClientType.MINOR && participant.legalGuardians.length === 1"
                                                >{{ 'form.the-tutor'|translate }}:</span
                                            >
                                        </td>
                                        <td><strong>{{ legalGuardian.name }}</strong>&nbsp;<strong>{{ legalGuardian.surname }}</strong></td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ legalGuardian.docId }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ legalGuardian.phone }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>-</strong>
                                        </td>
                                        <td class="text-right">
                                            <button
                                                type="button"
                                                class="btn-link"
                                                (click)="onEdit(participant)"
                                                *ngIf="isLastLG && !participant.preload"
                                            >
                                                <span *ngIf="participant.type === ClientType.DISABLED"
                                                    >{{ 'form.add-representative'|translate }} +</span
                                                >
                                                <span *ngIf="participant.type === ClientType.MINOR"
                                                    >{{ 'form.add-tutor'|translate }} +</span
                                                >
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </ng-container>
                        </ng-template>
                    </tbody>
                </table>
                <p class="mat-caption text-error font-italic mt-3 mb-0" *ngIf="errorMsg">{{ errorMsg|translate }}</p>
            </div>
        </div>

        <div class="row justify-content-between" *ngIf="!isAddingParticipant">
            <div class="col-12 col-md-5 col-lg-4 mb-3 mb-md-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAddParticipant()">
                    <span *ngIf="!isLegalPerson">{{ 'form.add-other-participant'|translate }}</span>
                    <span *ngIf="isLegalPerson">{{ 'form.add-other-attorney-in-fact'|translate }}</span>
                </button>
            </div>

            <div class="col-12 col-md-5 col-lg-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onSubmit()">
                    {{ 'general.next'|translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="bg-gray-gradient mt-2 py-4" *ngIf="isAddingParticipant">
        <thr-contract-form-participant
            [client]="editClient"
            [tutors]="tutors"
            [isFirst]="isFirst"
            [isLegalPerson]="isLegalPerson"
            (cancel)="onCancel()"
            (complete)="onCompleteParticipant($event)"
        ></thr-contract-form-participant>
    </div>
</main>
